import axios from "axios";

// env se base url
const BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Update Family Member API
 * @param {FormData} formData
 */
export const updateFamilyMemberAPI = (formData) => {
  console.log("🟢 API HIT:", `${BASE_URL}Customer/FamilyMemberUpdate`);

  return axios.post(
    `${BASE_URL}Customer/FamilyMemberUpdate`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
